import React from "react";
import {
  Edit,
  ReferenceInput,
  Datagrid,
  SimpleForm,
  TextInput,
  required,
  SelectInput,
  ImageInput,
  ImageField,
  NumberInput,
} from "react-admin";
import Grid from "@material-ui/core/Grid";

const TankEdit = (props) => {
  return (
    <Edit title={`Edit Tank`} {...props}>
      <SimpleForm style={{ width: "100%" }}>
        <TextInput source="name" />
        <div style={{ width: "100%" }}>
          <h3>Tank Size</h3>
          <Grid container spacing={2} style={{ width: "100%" }}>
            <Grid item xs={12} sm={6}>
              <NumberInput source="steps" label="Steps Feet" fullWidth />
            </Grid>
            <Grid item xs={12} sm={6}>
              <NumberInput source="distance" label="Distance KM" fullWidth />
            </Grid>
          </Grid>
        </div>
        <div style={{ width: "100%" }}>
          <Grid container spacing={2} style={{ width: "100%" }}>
            <Grid item xs={12} sm={6}>
              <NumberInput source="price" label="Price" fullWidth />
            </Grid>
            <Grid item xs={12} sm={6}>
              <NumberInput source="winAMA" label="AMA to win" fullWidth />
            </Grid>
          </Grid>
        </div>
        <div style={{ width: "100%" }}>
          <Grid container spacing={2} style={{ width: "100%" }}>
            <Grid item xs={12} sm={6}>
              <ReferenceInput
                label="Tank Before"
                source="tankBefore"
                reference="tanks"
                fullWidth
              >
                <SelectInput optionText="name" optionValue="id" />
              </ReferenceInput>
            </Grid>
            <Grid item xs={12} sm={6}>
              <NumberInput
                source="nextTankUpgradeTimes"
                label="Times to upgrade to next tank"
                fullWidth
              />
            </Grid>
          </Grid>
        </div>
        <ImageInput source="picture" label="Tank Image" accept="image/*">
          <ImageField source="src" title="title" />
        </ImageInput>
      </SimpleForm>
    </Edit>
  );
};

export default TankEdit;
